import './Loader.css';
import useLang from '../../hooks/use-lang/useLang.js';

export default function Loader({ text }) {
  const { t } = useLang();
  return (
    <div className="loader">
      <div className="loader__spinner" />
      <span className="loader__text">{text || t('common.loading', 'Loading…')}</span>
    </div>
  );
}
